import { Tag } from "@chakra-ui/tag";
import { FracaoForm } from "features/fracao/typings";
import { UnidadePaginateResponse } from "features/unidades/typings/unidade";
import colors from "core/resources/theme/colors";
import { useMemo } from "react";
import { Control } from "react-hook-form";
import Field from "components/Input/Field";
import InputMoney from "components/Input/InputMoney";

interface UseListagemFracoesColumnsProps {
  control: Control<FracaoForm, object>;
  enabledEdit: boolean;
}
function useListagemUnidadeColumns({
  control,
  enabledEdit,
}: UseListagemFracoesColumnsProps) {
  return useMemo(() => {
    return [
      {
        title: "Unidade",
        render: (original: UnidadePaginateResponse) => (
          <div>
            {original.numero} -{" "}
            <Tag variant="outline" colorScheme="blue">
              Bloco/Quadra: {original.blocoQuadra?.nome}
            </Tag>
          </div>
        ),
      },
      {
        title: "Fração",
        shouldCellUpdate: () => true,
        render: (original: UnidadePaginateResponse) => (
          <Field
            name={`unidades.${original.id}`}
            control={control}
            render={({ field, isInvalid }) => (
              <InputMoney
                value={field.value}
                onChange={field.onChange}
                isInvalid={isInvalid}
                disabled={!enabledEdit}
                placeholder="--"
                maxValue={100}
                decimalScale={8}
                decimalsLimit={8}
                backgroundColor={enabledEdit ? colors.blue100 : "transparent"}
                style={{
                  textAlign: "center",
                  width: "120px",
                  borderColor: "#00000000",
                }}
              />
            )}
          />
        ),
      },
    ];
  }, [control, enabledEdit]);
}

export default useListagemUnidadeColumns;
